// utils/safeJsonParse.ts
export const safeJsonParse = (raw: string): any | null => {
  if (!raw || typeof raw !== "string") return null;
  let candidate = raw.replace(/```(?:json)?/gi, "").replace(/```/g, "").trim();
  try {
    return JSON.parse(candidate);
  } catch {
    let fixed = candidate.replace(/,\s*(?=[}\]])/g, "");
    fixed = fixed.replace(/'([^'\\]*(\\.[^'\\]*)*)'/g, (_m, p1) => `"${p1.replace(/"/g, '\\"')}"`);
    fixed = fixed.replace(/([{,]\s*)([A-Za-z0-9_\-$]+)\s*:/g, '$1"$2":');
    try {
      return JSON.parse(fixed);
    } catch {
      return null;
    }
  }
};
